import { render } from "./PasswordResetFailed.vue?vue&type=template&id=60c8d22f&scoped=true"
import script from "./PasswordResetFailed.vue?vue&type=script&lang=js"
export * from "./PasswordResetFailed.vue?vue&type=script&lang=js"

import "./PasswordResetFailed.vue?vue&type=style&index=0&id=60c8d22f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c8d22f"]])

export default __exports__